<template>
  <FriedModal @close="$emit('close')">
    <template #header>
      <FriedModalHeader :header="modalTitle" />
    </template>
    <div class="participant-list-container">
      <FriedList class="participant-list-list">
        <FriedListItem
          v-for="participant of participants"
          :key="participant.id"
          :title="formatTitle(participant) || '-'"
          :description="participant.email || participant.phone"
        >
          <template #left>
            <div class="participant-list-icon-container">
              <FriedAvatar
                :name="name(participant) || participant.email"
                :thumb-url="participant.thumbUrl"
              />
            </div>
          </template>
        </FriedListItem>
      </FriedList>
    </div>
  </FriedModal>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { ParticipantHelper } from '@getaccept/dsr-shared-new/src/helpers/participant.helper';
import type { Participant } from '../types';

export default defineComponent({
  props: {
    participants: {
      type: Array as PropType<Partial<Participant>[]>,
      default: () => [],
    },
    modalTitle: {
      type: String,
      default: '',
    },
    showTitle: {
      type: Boolean,
    },
    showCurrentUserLabel: {
      type: Boolean,
    },
    currentUserId: {
      type: String,
      default: undefined,
    },
  },
  emits: ['close'],
  setup(props) {
    const { t } = useI18n();
    const name = (participant: Partial<Participant>) =>
      participant.fullName || ParticipantHelper.getFullName(participant);

    const titleText = (participant: Partial<Participant>) =>
      ParticipantHelper.formatTitleAndCompanyName(participant);

    const showYouLabel = (participant: Partial<Participant>) =>
      participant.id === props.currentUserId ? ` (${t('you')})` : '';

    const formatTitle = (participant: Partial<Participant>) =>
      props.showTitle
        ? props.showCurrentUserLabel
          ? `${name(participant)}${titleText(participant)}${showYouLabel(participant)}`
          : `${name(participant)}${titleText(participant)}`
        : `${name(participant)}${showYouLabel(participant)}`;

    return { formatTitle, name };
  },
});
</script>
